import { useDataChange } from 'Simple/Data.js'

export function useOnChange(props) {
  let change = useDataChange({
    context: 'settings',
    path: 'themeOverride.dark',
    viewPath: props.viewPath,
  })

  return function onChange(value) {
    change(value)
  }
}
